import { useEffect } from 'react';
import {
    TelegramShareButton,
    TelegramIcon,
} from 'next-share'

export const TelegramShareTemplate = ({ pageUrl, pageTitle }) => {
    useEffect(() => {
        // Add `rel="nofollow"` to the first anchor tag in this component
        const shareLinks = document.querySelectorAll('.telegram-share-button button');
        shareLinks.forEach((link) => {
            link.setAttribute('rel', 'nofollow');
        });
    }, []);
    return (
        <div className="telegram-share-button">
            <TelegramShareButton
                url={`${pageUrl}`}
                title={`${pageTitle}`}
            >
                <TelegramIcon size={44} round />
            </TelegramShareButton>
        </div>
    );
}
